import { render, staticRenderFns } from "./MobileHomeCarousel.vue?vue&type=template&id=018c549a&scoped=true&"
import script from "./MobileHomeCarousel.vue?vue&type=script&lang=ts&"
export * from "./MobileHomeCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHomeCarousel.vue?vue&type=style&index=0&id=018c549a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018c549a",
  null
  
)

export default component.exports